import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { dict } from "./dict";

const LangCtx = createContext({
  lang: "pl",
  setLang: () => {},
  t: (k) => k,
});

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("dc_lang") || "pl");

  const setLang = useCallback((next) => {
    localStorage.setItem("dc_lang", next);
    setLangState(next);
  }, []);

  const t = useCallback(
    (key) => dict[lang]?.[key] ?? dict.pl[key] ?? key,
    [lang]
  );

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>
  );
}

export const useLang = () => useContext(LangCtx);
